export default __webpack_public_path__ + "static/nocamels-c310478b5a4317763aae3982bc567c78.png";